"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOpenGraphQuery = exports.OPEN_GRAPH_QUERY = void 0;
var client_1 = require("@apollo/client");
var client_2 = require("@apollo/client");
var lodash_1 = require("lodash");
exports.OPEN_GRAPH_QUERY = (0, client_2.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query OpenGraph($url: String!) {\n    openGraph(url: $url) {\n      title\n      url\n      description\n      image\n      imageWidth\n      imageHeight\n      author\n      date\n      publisher\n      publisherUrl\n    }\n  }\n"], ["\n  query OpenGraph($url: String!) {\n    openGraph(url: $url) {\n      title\n      url\n      description\n      image\n      imageWidth\n      imageHeight\n      author\n      date\n      publisher\n      publisherUrl\n    }\n  }\n"])));
var useOpenGraphQuery = function (url, options) {
  var result = (0, client_1.useQuery)(exports.OPEN_GRAPH_QUERY, __assign(__assign({}, options || {}), {
    variables: __assign(__assign({}, options && options.variables || {}), {
      url: url
    })
  }));
  var loading = result.loading,
    data = result.data;
  if (!loading && data) {
    // const { openGraph = {} } = data; 
    var openGraph = data.openGraph || {};
    // map opengraph result to OpenGraphInfo type
    return __assign(__assign({}, result), {
      data: __assign(__assign({}, (0, lodash_1.pick)(openGraph, 'author', 'date', 'url', 'description', 'title')), {
        id: openGraph.id,
        image: openGraph.image && {
          id: openGraph.image,
          url: openGraph.image,
          height: openGraph.imageHeight,
          width: openGraph.imageWidth
        }
      })
    });
  }
  return result;
};
exports.useOpenGraphQuery = useOpenGraphQuery;
var templateObject_1;